import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FocusRow = ({ icon, label, detail, actionLabel, muted, to }) => {
  const content = (
    <>
      <div className="flex items-center gap-3 min-w-0">
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${muted ? 'bg-muted' : 'bg-accent/10'}`}>
          <Icon name={icon} size={15} className={muted ? 'text-muted-foreground' : 'text-accent'} />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-medium text-foreground truncate">{label}</p>
          {detail && <p className="text-xs text-muted-foreground truncate">{detail}</p>}
        </div>
      </div>
      {actionLabel && <span className="text-xs text-muted-foreground flex-shrink-0">{actionLabel}</span>}
    </>
  );

  const rowClass = `flex items-center justify-between gap-3 py-3 ${muted ? 'opacity-50' : ''}`;

  return to ? (
    <Link to={to} className={`${rowClass} hover:bg-muted/30 -mx-2 px-2 rounded-lg transition-smooth`}>
      {content}
    </Link>
  ) : (
    <div className={rowClass}>{content}</div>
  );
};

const TodaysFocusCard = ({ continueLearningEntry, todaysAppointment, pendingAssessmentsCount }) => {
  const hasAnyFocus = continueLearningEntry || todaysAppointment || pendingAssessmentsCount > 0;

  return (
    <div className="bg-white/60 backdrop-blur-xl border border-white/40 rounded-xl p-5">
      <h3 className="text-sm font-semibold text-foreground mb-1">Today's Focus</h3>
      <p className="text-xs text-muted-foreground mb-2">
        {hasAnyFocus ? "What's on deck for today." : 'Nothing scheduled yet, a good day to start something.'}
      </p>
      <div className="divide-y divide-border/60">
        {continueLearningEntry && (
          <FocusRow
            icon="PlayCircle"
            label="Continue learning"
            detail={continueLearningEntry?.course?.title}
            actionLabel="Resume"
            to={`/video-learning-interface?orgId=${continueLearningEntry?.enrollment?.orgId}&courseId=${continueLearningEntry?.enrollment?.courseId}${
              continueLearningEntry?.nextLesson?.id ? `&lessonId=${continueLearningEntry?.nextLesson?.id}` : ''
            }`}
          />
        )}
        {todaysAppointment && (
          <FocusRow
            icon="HeartHandshake"
            label="Mentor session today"
            detail={new Date(todaysAppointment.scheduledForMs).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}
            actionLabel="View"
            to={`/mentee-workspace?mentorshipId=${todaysAppointment.mentorshipId}`}
          />
        )}
        {pendingAssessmentsCount > 0 && (
          <FocusRow
            icon="ClipboardCheck"
            label={`${pendingAssessmentsCount} pending assessment${pendingAssessmentsCount === 1 ? '' : 's'}`}
          />
        )}
        <FocusRow icon="Trophy" label="Challenges" actionLabel="Coming soon" muted />
      </div>
    </div>
  );
};

export default TodaysFocusCard;